export const ACCESS_TOKEN_COOKIE = '_rf_access';
export const REFRESH_TOKEN_COOKIE = '_rf_refresh';
export const UID_COOKIE = '_rf_uid';
export const EMAIL_COOKIE = '_rf_email';
